// Shared motion language.
// Values mirror the Ortexo site so both properties feel like one family:
// a container that staggers its children, items that spring in from below.

export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.2 },
  },
};

export const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 100, damping: 12 },
  },
};

// Tighter stagger for dense grids (six principle cards, four stat tiles)
export const gridVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.06, delayChildren: 0.1 },
  },
};

// Headline lines rise out of an overflow mask — the "wow" reveal.
export const lineVariants = {
  hidden: { y: '110%', opacity: 0 },
  visible: {
    y: '0%',
    opacity: 1,
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
  },
};

// Blur-swap used by rotating words.
export const swapVariants = {
  hidden: { opacity: 0, y: 12, filter: 'blur(8px)' },
  visible: { opacity: 1, y: 0, filter: 'blur(0px)' },
  exit: { opacity: 0, y: -12, filter: 'blur(8px)' },
};

export const swapTransition = { duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] };

// Product surface panels rise with a touch of perspective.
export const surfaceVariants = {
  hidden: { opacity: 0, y: 48, rotateX: 8 },
  visible: {
    opacity: 1,
    y: 0,
    rotateX: 0,
    transition: { duration: 1.1, ease: [0.16, 1, 0.3, 1], delay: 0.35 },
  },
};

// Default viewport config: play once, trigger a little before fully in view.
export const viewportOnce = { once: true, amount: 0.2, margin: '0px 0px -80px 0px' };
